import { LegalCaseActions } from './actions'
import { LegalCaseGetters } from './getters'
import { LegalCaseMutations } from './mutations'
import { LegalCaseState } from './state'
export { REQUIRED_PROPERTIES } from './partials/edit'

export const LEGAL_CASE_NAMESPACE = 'legalCase'

export const LegalCase = {
  namespaced: true,
  state: LegalCaseState,
  actions: LegalCaseActions,
  mutations: LegalCaseMutations,
  getters: LegalCaseGetters,
}
